import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { couponsAccessRoles } from './access';

export const couponsRoutes: RouteObject[] = [
  {
    path: 'coupons',
    async lazy() {
      const { CouponsPage } = await import('./pages/CouponsPage');
      return { Component: CouponsPage };
    },
    handle: defineHandle({
      roles: [...couponsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.coupons',
    }),
  },
  {
    path: 'coupons/:id',
    async lazy() {
      const { CouponDetailPage } = await import('./pages/CouponDetailPage');
      return { Component: CouponDetailPage };
    },
    handle: defineHandle({
      roles: [...couponsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.coupons',
    }),
  },
];
